import React from 'react';
import ReactDOM from 'react-dom/client';
// 🎨 Pretendard Variable — 자체 호스팅(npm pretendard, 오프라인 PWA 대응).
//   08-23 전역 승격: 07-22엔 단타탭만 import했는데, 이제 전 화면이 같은 글꼴을 쓴다(index.css의 body가 참조).
import 'pretendard/dist/web/variable/pretendardvariable.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// 줍줍 PWA — 서비스워커 등록(설치 + 웹푸시 토대). 실패해도 앱은 정상 동작.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => { /* noop */ });
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
